
import DataEmpty from "@/views/components/DataEmpty/DataEmpty.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { ProgressBar } from "@/views/components";
import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
import config from "./config";
import TableHeader from "./TableHeader.vue";
import Enumerable from "linq";
import { LogHelper } from "@/common/LogHelper";

@Component({
  name: "InboundVirtualPacketPrint",
  components: {
    YtoTable,
    TableHeader,
    ProgressBar,
    DataEmpty,
  },
})
export default class extends Vue {
  @Watch("inputModel.input_NameType", { deep: false })
  onPackageNameChanged(val: string, oldVal: string) {
    if (val === "OrgCodeName") {
      this.orgCodeDisabled = false;
      this.$nextTick(function () {
        this.selectElementContents(document.getElementById("idInputNameTxt"));
      });
    } else {
      this.orgCodeDisabled = true;
      this.inputModel.input_OrgCodeName = "";
      this.$nextTick(function () {
        this.table1Loading = true;
      });
      setTimeout(() => {
        var orgs = obj_InboundVirtualPacketPrint.getOrgInfo(null, "");
        var resultData = JSON.parse(orgs);
        if (resultData.respcode === "000") {
          // this.printDataResultShowList = resultData.data;
          if (resultData.data != null) {
            var newArray = resultData.data?.map(function (item) {
              return {
                countNum: "",
                // ID: item.ID,
                orgName: item.orgName,
                orgCode: item.orgCode,
                printKeyWord:item.printKeyWord,
                matchCode: item.matchCode,
                subdivisionCode: item.subdivisionCode,
                printCount: item.printCount,
                // Count: item.Count,
                edit: false,
              };
            });
            this.printDataResultShowList = newArray;
          }
        }
        this.table1Loading = false;
      }, 500);
    }
  }
  created() {
    this.orgCodeDisabled = true;
    this.inputModel.input_NameType = "CenterCodeName";
    this.table1Loading = true;
  }
  mounted() {
    try {
      //注册查询打印结果数据回传
      obj_InboundVirtualPacketPrint.regist_PrintedDataCallback(
        this.PrintedDataCallback
      );
      //注册回传打印数量
      obj_InboundVirtualPacketPrint.regist_PrintedCountCallback(
        this.PrintedCountCallback
      );
    } catch (error) {
      LogHelper.Console("包签打印界面:注册回调函数异常" + error);
    }
    var el = document.getElementById("input_scancode_id");
    this.selectElementContents(el);
  }
  private tableRowClassName({ row, rowIndex }) {
    row.row_index = rowIndex;
  }
  private SearchOrgCodeNameFunc() {
    // this.table1Loading = true;
    var searchKey = this.inputModel.input_OrgCodeName;
    setTimeout(() => {
      var orgs = obj_InboundVirtualPacketPrint.getOrgInfo("", searchKey);
      var resultData = JSON.parse(orgs);
      if (resultData.respcode === "000") {
        this.printDataResultShowList = resultData.data;
      }
      // this.table1Loading = false;
    }, 500);
  }

  private printCount = 0;
  private totalCount = 0;

  private inputModel: inputDataModel_InboundVirtualPacketPrint = {
    input_UserCode: "",
    input_NameType: "",
    input_OrgCodeName: "",
    input_PaperSize: "",
    input_LatticeSchemeName: "",
    input_ThreeCode:"",
  };
  public table1Loading = false;
  private progressBarDialogTitle = "";

  private PrintedCountCallback(printLoadingData) {
    this.printCount = printLoadingData.printedCount;
    this.totalCount = printLoadingData.totalCount;
    this.proressBarDialogShow = printLoadingData.loadingEnable;
    this.progressBarDialogTitle = printLoadingData.title;
  }

  private proressBarDialogShow = false;

  private SubmitPrintFunc() {
    obj_InboundVirtualPacketPrint.submitPrint(this.multipleSelection);
  }

  private progressBarFormCloseFunc() {}
  public orgCodeDisabled = true;
  public options = [
    {
      value: "",
      label: "",
    },
  ];

  private loadingshowFunc() {}

  private currentRowIndex = "";
  private PrintedDataCallback(printedDatas) {
    this.searchResultShowList = printedDatas;
  }
  private onRowClick(row, event, column) {
    this.currentRowIndex = row.row_index;
  }
  private handelSelectPrintRow(selection, row, index) {
    this.multipleSelection = selection;
    this.$nextTick(() => {
      var el = document.getElementById("editinput" + row.row_index);
      this.selectElementContents(el);
    });
  }
  private requestDataModel:any = {
    orgName: "",
    orgCode: "",
    subdivisionCode: "",
    printKeyWord:""
  };

  private getFocus(row) {
    this.requestDataModel = {
      orgCode: row.orgCode,
      orgName: row.orgName,
      subdivisionCode: row.subdivisionCode,
      printKeyWord: row.printKeyWord,
    };
  }
  private loseFocus(row) {
    var _requestDataModel = this.requestDataModel;
    if (
      row.orgCode !== _requestDataModel.orgCode ||
      row.printKeyWord !== _requestDataModel.printKeyWord ||
      row.subdivisionCode !== _requestDataModel.subdivisionCode
    ) {
      obj_InboundVirtualPacketPrint.saveBagOrg(
        row.orgCode,
        row.printKeyWord,
        row.subdivisionCode
      );
    }
  }

  private cellClick(row, column) {
    row.seen = true;
  }

  private printDataResultShowList = [
    // {
    //   ID: "",
    //   Name: "嘉峪关中转包-934",
    //   UnpackOrgName: "甘肃嘉峪关接驳点",
    //   Type: "汽运",
    //   edit: false,
    //   Count: "",
    //   UnpackOrgCode: ""
    // }
  ];
  public multipleSelection = [];

  public handleSelectionChange(val) {
    this.multipleSelection = val;
    // if (val.length == 0) {
    //   for (
    //     let index = 0;
    //     index < this.printDataResultShowList.length;
    //     index++
    //   ) {
    //     this.printDataResultShowList[index].edit = false;
    //   }
    // }
  }

  private searchResultShowList = [];

  //获得焦点，选中文本
  private getInputFocus(event): void {
    event.currentTarget.select();
  }

  private config = config;

  public selectElementContents(el) {
    try {
      el.blur();
      el.focus();
    } catch (error) {
      LogHelper.Console("selectElementContents error：" + error);
    }
  }

  public UnpackOrgName = "";
}
